import { render, staticRenderFns } from "./CoWeekInterval.vue?vue&type=template&id=a65e5a76&scoped=true&"
import script from "./CoWeekInterval.vue?vue&type=script&lang=ts&"
export * from "./CoWeekInterval.vue?vue&type=script&lang=ts&"
import style0 from "./CoWeekInterval.vue?vue&type=style&index=0&id=a65e5a76&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65e5a76",
  null
  
)

export default component.exports